export const AGREEMENT_EVENT_NAMES = {
  agreementStarted: 'Agreement Started',
  agreementSent: 'Agreement Sent',
  agreementAccepted: 'Agreement Accepted',
  agreementDeclined: 'Agreement Declined',
  amendedAgreementAccepted: 'Amended Agreement Accepted',
  amendedAgreementDeclined: 'Amended Agreement Declined',
  agreementTerminated: 'Agreement Terminated',
  agreementViewed: 'Agreement Viewed',
  agreementWidgetTapped: 'Agreements widget tapped on mobile',
  agreementSummaryTappedOnAgreementsTab: 'Agreements summary tapped from agreements tab on mobile',
  agreementExited: 'agreement_exited',
} as const;
